<template>
    <div>
        <p
            v-if="label != null"
            class="text-14 pb-1 transition-all duration-300 ease-in-out"
            :class="[disabled ? 'text-grey-600' : 'text-grey-900']"
        >
            {{ label }}
        </p>

        <!-- <div class="flex justify-between">
            <p v-if="label != null" :class="[disabled ? 'label-disabled' : '']" class="text-14 text-grey-900 pb-1 transition-all duration-300 ease-in-out">
                {{ $help.capitalizeFirstLetter(label) }}
            </p>

            <slot name="label-right" />
        </div> -->

        <div
            :class="[boxClass, [error ? 'border-error' : 'border-grey-500'], [disabled ? 'disabled' : '']]"
            class="input-group"
            @click="$refs.input.focus()"
            @focusin="canFoucs ? f() : () => {}"
            @focusout="canFoucs ? b($event) : () => {}"
        >
            <slot :isFocused="isFocused" name="left" />

            <div class="relative w-full">
                <input
                    ref="input"
                    :disabled="disabled"
                    :name="name"
                    :placeholder="placeholder"
                    :type="type"
                    :value="value"
                    :autocomplete="autocomplete"
                    class="input"
                    @blur="inputBlur"
                    @focus="inputFocused"
                    @input="update"
                    @keyup="$emit('onKeyup', $event)"
                />

                <div v-if="value != null && value != '' && !inputIsFocused" class="absolute inset-0 z-[1] px-3 pt-px flex items-center">
                    <p class="text-transparent opacity-0">{{ value }}</p>
                    <p class="text-grey-900">
                        <span v-if="spaceAfterValue">&nbsp;</span>{{ typeof afterValue == 'function' ? afterValue(value) : afterValue }}
                    </p>
                </div>

                <div
                    v-if="
                        value != null &&
                        value != '' &&
                        value != 0 &&
                        String(value).length > 0 &&
                        !inputIsFocused &&
                        this.$slots.preview != undefined
                    "
                    class="absolute inset-0 z-10 px-3 flex items-center cursor-text input-preview text-15"
                >
                    <slot :value="value" name="preview" />
                </div>
            </div>

            <p
                v-if="limit !== null"
                class="text-grey-900 text-12 shrink-0 px-4"
                :class="{
                    'text-red-700': (value != null ? value.length : 0) > limit,
                }"
            >
                {{ value != null ? value.length : 0 }} / {{ limit }}
            </p>

            <slot :isFocused="isFocused" name="right" />

            <tippy :offset="[2, 4]" maxWidth="100%" placement="bottom-end">
                <button
                    v-if="ai[name] != null"
                    class="w-12 h-12 flex items-center justify-center"
                    type="button"
                    @click="setAIValue(ai[name])"
                >
                    <IconZap class="stroke-grey-800" />
                </button>

                <template #content>
                    <p>Generated by Call Assistant</p>
                </template>
            </tippy>
        </div>

        <Error v-if="!hideError" :error="error">
            <template #errorAfter>
                <slot name="errorAfter" :error="error" />
            </template>
        </Error>
    </div>
</template>

<script>
import Input from '~/mixins/input.js'

export default {
    mixins: [Input],
}
</script>
